import type { SearchHistoryStyles } from '~/features/search-history';
import { tw } from '~/utils';

export const searchHistoryStyles = tw<SearchHistoryStyles>({
  box: 'flex flex-col gap-2',
  item: 'flex items-center justify-between',
  keyword: 'text-body-s hover:underline',
  closeButton: 'text-grey-500 p-2 hover:cursor-pointer',
});
